export const events = {
  eventsCardDurationText: 'Duração',
  eventsSearchInputText: 'Buscar',
  eventsRegisteredToEventAlertTitle: 'Registrado com sucesso',
  eventsUnregisteredToEventAlertTitle: 'Desregistrado com sucesso',
  eventsExternalRegistrationPopupTitle: 'Registrar',
  eventsExternalRegistrationPopupContent: 'Você foi registrado com sucesso?',
  eventsExternalRegistrationNoButtonTitle: 'Não',
  eventsExternalRegistrationYesButtonTitle: 'Sim',
  eventsCurtainCopyOptionTitle: 'Copiar link',
  eventsCurtainFlagOptionTitle: 'Denunciar conteúdo',
  eventsLinkCopiedAlertText: 'Link copiado!',
  eventsCurtainAddToCalendOptionTitle: 'Adicionar ao calendário',
  eventdetailsAgendaButtonTitle: 'Agenda',
  eventdetailsOnMapButtonTitle: 'No mapa',
  eventdetailsOnlineLocationTitle: 'Online',
  eventdetailAmountsRegisteredText: 'Participantes',
  eventdetailsSeeAllButtonTitle: 'Ver todos',
  eventdetailsRegisteredButtonTitle: 'Registrar',
  eventdetailsRegisterButtonTitle: 'Registrar',
  eventdetailsRegisteredAlertText: 'Registrado com sucesso',
  eventdetailsUnregisteredAlertText: 'Desregistrado com sucesso',
  eventdetailsAgendaTitle: 'Agenda',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Usuários registrados',
  eventdetailsSpeakersCurtainTitle: 'Palestrantes',
  eventdetailsSpeakersSectionTitle: 'Palestrantes',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'Ver todos',
  eventdetailsCustomSectionSeeAllButtonTitle: 'Ver todos',
  eventdetailsCurtainCopyOptionTitle: 'Copiar link',
  eventdetailsCurtainFlagOptionTitle: 'Denunciar conteúdo',
  eventsdetailsLinkCopiedAlertText: 'Link copiado!',
  eventdetailsCurtainAddToCalOptionTitle: 'Adicionar ao calendário',
  eventDetailsAddCalendarPopupTitle: 'Calendário',
  eventdetailsAddCalendarPopupContent: 'Adicionar ao calendário?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'Não',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Sim',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Copiar link',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Denunciar conteúdo',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Link copiado!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Copiar link',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Denunciar conteúdo',
  eventsFlag: 'Denunciar',
  eventsJoin: 'Participar',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Link copiado!',
  eventContentReported: 'Conteúdo denunciado',
  eventsError: 'Algo deu errado!',
  eventdetailsExternalRegistrationPopupContent: 'Você foi registrado com sucesso?',
  eventdetailsExternalRegistrationNoButtonTitle: 'Não',
  eventdetailsExternalRegistrationYesButtonTitle: 'Sim',
  eventdetailsExternalRegistrationPopupTitle: 'Registrar',
  eventsCardRegisteredButtonTitle: 'Registrados',
  eventsCardRegisterButtonTitle: 'Registrar',
  eventsJoinLink: 'Link para participar: [url]{link}[/url][br]',
  eventsGuest: 'Convidado',
  eventsNoSessionInDay: 'Não há eventos neste dia.',
  eventsShowUpcomingEvent: 'Mostrar próximo evento'
}
